import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';

export const TlsCertificateNameField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<>
			{deviceForFullInfo?.useTlsCertificate && (
				<FullInfoField label="tlsCertificateNameLabel" value={deviceForFullInfo?.tlsCertificateName} />
			)}
		</>
	);
};
